import { currencies } from "@megaron/catalog-contracts";
import { HttpAction } from "@megaron/http-service";
import { Serializers, SerializerValue } from "@megaron/serializers";
import { solutionSerializer } from "@megaron/shipping-contracts";
import { uuidSerializer } from "@megaron/uuid";

export const orderShippingPreviewInputSerializer = Serializers.first(
  Serializers.object({
    source: Serializers.stringOneOf("order" as const),
    orderNumber: Serializers.string,
  }),
  Serializers.object({
    source: Serializers.stringOneOf("draft" as const),
    draftUuid: uuidSerializer,
  }),
);

export type OrderShippingPreviewInput = SerializerValue<typeof orderShippingPreviewInputSerializer>;

export const orderShippingPreviewSerializer = Serializers.object({
  priceList: Serializers.string,
  currency: Serializers.stringOneOf(...currencies),
  solution: solutionSerializer,
});

export type OrderShippingPreview = SerializerValue<typeof orderShippingPreviewSerializer>;

export const orderShippingActions = {
  orderShippingPreview: HttpAction({
    path: "/orders/shippingPreview",
    method: "post",
    requiresAuth: true as const,
    bodySerializer: orderShippingPreviewInputSerializer,
    valueSerializer: orderShippingPreviewSerializer,
    errorSerializer: Serializers.stringOneOf(
      "OrderNotFound",
      "DraftNotFound",
      "InvalidShippingItemQuantity",
      "ShippingUnavailable",
      "CatalogUnavailable",
      "ShippingPriceListNotFound",
      "NoSolution",
    ),
  }),
};
